import React from "react";
import {useCart} from "../Cart/CartContext";
import {HiOutlineShoppingCart} from "react-icons/hi2";
import './BadgeCartQuantity.css';

const BadgeCartQuantity: React.FC = () => {
    const {cart} = useCart();

    // The rule for each quantity in the cart
    // const totalQuantity = cartItems ? cartItems.reduce((acc, item) => acc + item.quantity, 0) : 0;
    let totalQuantity;
    
        totalQuantity = (cart?.items?.stockItems?.length ?? 0) + (cart?.items?.transitItems?.length ?? 0);
    
    if (totalQuantity === 0) {
        return (
            <div>
                <HiOutlineShoppingCart className="transition hover:text-white/75"/>
            </div>
        );
    }
    
    return (
        <div className="relative">
            <HiOutlineShoppingCart className="transition hover:text-white/75"/>
            {totalQuantity && <>
                <span
                    className="absolute bottom-4 left-4 inline-flex items-center justify-center px-2 py-1 text-xs font-bold leading-none text-red-100 bg-red-400 rounded-full">
                    {totalQuantity ? (totalQuantity < 999 ? totalQuantity : '999+') : '0'}
                </span>
            </>}
        </div>
    );
};
export default BadgeCartQuantity;
